module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px",
      "show-close": !_vm.isCreating
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.isCreating) ? _c('div', {
    staticClass: "last-checks"
  }, [_c('h2', [_vm._v("Kontaktuppgifter")]), _vm._v(" "), (!_vm.isAddonBooking) ? _c('div', [_c('p', [_vm._v("Komplettera eller säkerställ att följande uppgifter stämmer.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("OBS!")]), _vm._v(" Det är dessa uppgifter vi använder för att nå dig. Det är viktigt att informationen är korrekt.")])]) : _vm._e(), _vm._v(" "), (_vm.isAddonBooking) ? _c('div', [_c('p', [_vm._v("Följande kontaktuppgifter är registrerade på din bokning, kontrollera att de stämmer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Om du behöver uppdatera uppgifterna kan du göra det direkt under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goToMyPages
    }
  }, [_vm._v("Mina sidor")]), _vm._v(" eller genom att kontakta gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "static": true
    }
  }), _vm._v(" "), (!_vm.loading && !_vm.isAddonBooking) ? _c('div', [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ditt telefonnummer",
      "value": _vm.phone
    },
    on: {
      "change": _vm.updatePhone
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "name-input"
  }, [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ditt förnamn",
      "value": _vm.name
    },
    on: {
      "change": _vm.updateFirstName
    }
  }), _vm._v(" "), _c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Efternamn",
      "value": _vm.lastName
    },
    on: {
      "change": _vm.updateLastName
    }
  })], 1), _vm._v(" "), _c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Din e-postadress",
      "value": _vm.email
    },
    on: {
      "change": _vm.updateEmail
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Ditt land "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('CountrySwitcherNormal', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    }
  }), _vm._v(" "), (!_vm.smsSent && _vm.errors.length) ? _c('div', {
    staticClass: "error-message"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.enableQuickLogin) ? _c('div', {
    staticClass: "info-box--blue"
  }, [_c('p', [_vm._v(_vm._s(_vm.enableQuickLogin))]), _vm._v(" "), (this.loggedIn) ? _c('p', [_vm._v("Notera att du kommer att bli utloggad från det konto du nu är inloggad på.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.errors2.length) ? _c('div', {
    staticClass: "error-message"
  }, _vm._l((_vm.errors2), function(error) {
    return _c('p', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.smsSent) ? _c('div', [(_vm.enableQuickLogin) ? _c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.sendCodeSms
    }
  }, [_vm._v("Skicka SMS-kod")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (_vm.enableQuickLogin) ? _c('button', {
    staticClass: "small white border",
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.smsSent) ? _c('div', [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ange koden som du fått via SMS",
      "value": _vm.smsCode
    },
    on: {
      "change": _vm.updateSmsCode
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkCode
    }
  }, [_vm._v("Verifiera")])], 1) : _vm._e(), _vm._v(" "), (!_vm.enableQuickLogin) ? _c('div', [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.isAddonBooking) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_vm._v("Ditt telefonnummer:")]), _c('br'), _vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ditt namn:")]), _c('br'), _vm._v(_vm._s(_vm.name) + " " + _vm._s(_vm.lastName))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Din e-postadress:")]), _c('br'), _vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ditt land:")]), _c('br'), _vm._v(_vm._s(_vm.country))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")]), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.localCloseModal
    }
  }, [_vm._v("Gå tillbaka")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('CreatingOrder', {
    attrs: {
      "show-texts": true,
      "do-redirect": _vm.doRedirect
    },
    on: {
      "callback": _vm.onSyncCallback
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('button', {
    staticClass: "small white border",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Avbryt")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7d8566a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CreatingOrder.vue
// module id = 1021
// module chunks = 0